import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { AppSettings } from './app-settings';
import { DOCUMENT } from '@angular/common';
import { environment } from '@deltager/organizers/admin/environments/environment';
import { Router } from '@angular/router';

@Injectable()
export class AppSettingsService {
  settingSubject: BehaviorSubject<AppSettings>;
  settingsValue: AppSettings;

  public affiliateId: number;
  public baseUrl: string;

  constructor(
    private cookieService: CookieService,
    @Inject(DOCUMENT) private document: any,
    private router: Router,
  ) {
    const affIdFromHost = document.querySelector('app-root')?.getAttribute('affiliateid');
    this.affiliateId = affIdFromHost
      ? +affIdFromHost
      : parseInt(cookieService.get('affId'), 0) || environment.defaultAffiliateId;

    this.settingsValue = new AppSettings(this.affiliateId, document.location.origin);
    this.settingSubject = new BehaviorSubject<AppSettings>(this.settingsValue);
    this.setAffIdToCookie(this.affiliateId);
  }

  get Settings(): Observable<AppSettings> {
    return this.settingSubject.asObservable();
  }

  public setNewAffId(affId: number) {
    this.affiliateId = affId;
    this.settingsValue.affiliateId = affId;
    this.settingSubject.next(this.settingsValue);
    this.setAffIdToCookie(affId);
  }

  setLaunchedFromLegacySite(value: boolean) {
    this.settingsValue.launchedFromLegacySite = value;
    this.settingSubject.next(this.settingsValue);
  }

  setBaseUrl(url: string) {
    this.baseUrl = url || document.location.origin;
    this.settingsValue.baseUrl = url;
    this.settingSubject.next(this.settingsValue);
  }

  goToExternalUrl(url: string): void {
    this.document.location.href = url;
  }

  goToExternalUrlFromBase(url: string): void {
    this.document.location.href = this.getExternalUrlFromBase(url);
  }

  getExternalUrlFromBase(url: string): string {
    return this.baseUrl + url;
  }

  getUrlLinkWithHref(url: string, linkText: string): string {
    return `<a href='${this.baseUrl}/${url}' target='_blank'>${linkText}</a>`;
  }

  getUrlWithBaseUrl(url: string): string {
    return `${this.baseUrl}/${url}`;
  }
  goToUrlFromBaseInNewWindow(url: string, width: number, height: number): void {
    const left = screen.width / 2 - width / 2;
    const top = screen.height / 2 - height / 2;

    window.open(
      this.baseUrl + url,
      '_blank',
      `location=yes,height=${height},width=${width},top=${top}, left=${left}, scrollbars=yes,status=no,resizable=yes`,
    );
  }

  public goToLogin(): void {
    if (this.isLocalEnv()) {
      this.router.navigate(['/login']);
    } else {
      this.goToExternalUrlFromBase('/logout.aspx?ReturnURL=/arrangement/');
    }
  }

  private setAffIdToCookie(affId: number): void {
    this.cookieService.set('affId', affId.toString(), 50, '/');
  }

  private isLocalEnv(): boolean {
    const hostname = window.location && window.location.hostname;
    return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
  }
}
